import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const TestimonialsSlider = () => {
    const width = window.innerWidth;

    const settings = {
        dots: false,
        infinite: true,

        /* Super Smooth */
        speed: 5000,
        cssEase: "linear",

        /* Auto Slide */
        autoplay: true,
        autoplaySpeed: 0,

        /* Responsive Slides */
        slidesToShow:
            width <= 768
                ? 1      // Mobile
                : width <= 1024
                    ? 2   // Tablet
                    : 3,  // Desktop

        slidesToScroll: 1,

        pauseOnHover: false,
        pauseOnFocus: false,

        arrows: false,
        swipe: true,

        /* Smooth Center */
        centerMode: true,
        centerPadding: "0px",

        /* Performance */
        adaptiveHeight: false,
        draggable: true,
        useTransform: true,
    };
    const testimonials = [
        {
            name: "Michael Carter",
            role: "Startup Founder",
            image:
                "https://randomuser.me/api/portraits/men/32.jpg",
            review:
                "AppVerseLabs transformed our app idea into a premium mobile experience with smooth animations and flawless performance.",
        },
        {
            name: "Sophia Williams",
            role: "Product Manager",
            image:
                "https://randomuser.me/api/portraits/women/44.jpg",
            review:
                "The UI/UX quality and mobile app performance exceeded expectations. Truly premium work.",
        },
        {
            name: "Daniel Brown",
            role: "CEO, Fintech Company",
            image:
                "https://randomuser.me/api/portraits/men/75.jpg",
            review:
                "Best app development team we've worked with. Everything from design to deployment felt world-class.",
        },
        {
            name: "Emily Watson",
            role: "Business Owner",
            image:
                "https://randomuser.me/api/portraits/women/68.jpg",
            review:
                "Our mobile app now feels incredibly modern and users love the experience.",
        },
    ];

    return (
        <>
            <section className="testimonial-section">

                {/* Glow */}
                <div className="testimonial-glow glow-1"></div>
                <div className="testimonial-glow glow-2"></div>

                <div className="testimonial-container">

                    {/* Heading */}
                    <div className="testimonial-heading">

                        <span className="testimonial-badge">
                            CLIENT TESTIMONIALS
                        </span>

                        <h2>
                            Clients Love
                            <span> AppVerseLabs.</span>
                        </h2>

                        <p>
                            Premium app development experiences
                            with smooth UI, scalable architecture
                            and beautiful animations.
                        </p>

                    </div>

                    {/* Slider */}
                    <Slider {...settings}>

                        {testimonials.map((item, index) => (
                            <div key={index} className="slide-padding">

                                <div className="testimonial-card">

                                    <div className="card-glow"></div>

                                    <div className="quote-icon">
                                        ❝
                                    </div>

                                    <p className="testimonial-review">
                                        {item.review}
                                    </p>

                                    <div className="testimonial-user">

                                        <div className="testimonial-user-img-wrap">
                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                className="testimonial-user-img"
                                            />
                                        </div>

                                        <div>
                                            <h4>{item.name}</h4>
                                            <span>{item.role}</span>
                                        </div>

                                    </div>

                                    <div className="testimonial-stars">
                                        ★★★★★
                                    </div>

                                </div>

                            </div>
                        ))}

                    </Slider>

                </div>

            </section>
        </>
    );
};

export default TestimonialsSlider;